<template>
  <span
    class="caret-container flex-center radial-hover-secondary"
    :style="{ width: `${size}px`, height: `${size}px` }"
    @click="$emit('click', $event)"
  >
    <i class="caret caret-heavy-right-icon" :class="{ expanded: expanded }" :style="iconSize"></i>
  </span>
</template>

<script>
/**
 * This component provides a caret icon. This can be typically used as CTA in scenarios where expand/collapse is needed
 */
export default {
  name: 'CollapseCaret',
  props: {
    expanded: { default: false, type: Boolean },
    size: { default: 23, type: Number },
    containerToIconRatio: { default: 0.4, type: Number }
  },
  data() {
    const iconHeight = Math.round(this.size * this.containerToIconRatio)
    return {
      iconSize: {
        height: `${iconHeight}px`,
        width: `${Math.round(iconHeight * 0.77)}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/_hoverStates.scss';

i.caret {
  transition: all ease-in 100ms;
}
.caret-container {
  cursor: pointer;
  border-radius: 4px;
  z-index: 0;
  &:hover {
    .caret {
      opacity: 1;
    }
  }
  .caret {
    opacity: 0.5;
  }
}
.caret-heavy-right-icon.caret {
  transform: rotate(0deg);
  &.expanded {
    transform: rotate(90deg);
  }
}
</style>
